/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';

import disabledPage from 'assets/img/previousPage.svg';
import enabledPage from 'assets/img/nextPage.svg';
import {
  Container, ArrowRight, ArrowLeft, Number,
} from './styles';

export default function NewPagination({
  changePage, offset, length, full,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [lenghtPages, setLengthPages] = useState(0);

  const leftActive = offset > 0;
  const rightActive = offset + length < full;

  const handleChangePage = (page) => {
    if (page === currentPage || typeof page !== 'number') {
      return false;
    }
    changePage(length * (page - 1));
    setCurrentPage(page);
  };

  const getNumbers = () => {
    const numbers = [];
    if (lenghtPages <= 7) {
      for (let i = 1; i <= lenghtPages; i++) {
        numbers.push(i);
      }
    } else if (currentPage === 1) {
      for (let i = 1; i <= 5; i++) {
        numbers.push(i);
      }
      numbers.push('...');
      numbers.push(Math.ceil(full / length));
    } else if (currentPage === Math.ceil(full / length)) {
      numbers.push(1);
      numbers.push('...');

      for (let i = Math.ceil(full / length) - 4; i <= Math.ceil(full / length); i++) {
        numbers.push(i);
      }
    } else {
      if (currentPage !== 2) {
        numbers.push(1);
        numbers.push('...');
      }

      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        numbers.push(i);
      }

      if (numbers.length < 5) {
        for (let i = numbers.length; i <= 5; i++) {
          if (!numbers.includes(i)) {
            numbers.push(i);
          }
        }
      }

      if (Math.ceil(full / length) - 1 !== currentPage) {
        numbers.push('...');
        numbers.push(Math.ceil(full / length));
      }
    }


    return (
      numbers.map((number, i) => (
        <Number key={`${i} page `} onClick={() => handleChangePage(number)} active={currentPage === number}>{number}</Number>
      ))
    );
  };

  useEffect(() => {
    setLengthPages(Math.ceil(full / length));
    setCurrentPage(offset === 0 ? 1 : (offset / length) + 1);
  }, [offset, full, length]);
  return (
    <Container>
      <ArrowLeft
        onClick={() => {
          if (leftActive) handleChangePage(currentPage - 1);
        }}
        src={leftActive ? enabledPage : disabledPage}
        active={leftActive}
      />
      {getNumbers()}
      <ArrowRight
        onClick={() => {
          if (rightActive) handleChangePage(currentPage + 1);
        }}
        src={rightActive ? enabledPage : disabledPage}
        active={rightActive}
      />
    </Container>
  );
}
